import { render, staticRenderFns } from "./Anagrafica4.vue?vue&type=template&id=6ed59c92&"
import script from "./Anagrafica4.vue?vue&type=script&lang=js&"
export * from "./Anagrafica4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports